import React, { FC, ReactNode } from "react";

import styles from "./Callout.module.scss";
import { Button } from "../Button/Button";
import { Container } from "../Container/Container";

export interface CalloutProps {
	headingText?: ReactNode;
	ctaText?: ReactNode;
	ctaHref?: string;
	ctaSecondaryText?: ReactNode;
	ctaSecondaryHref?: string;
	[key: string]: unknown;
}

export const Callout: FC<CalloutProps> = ({
	headingText = <>Get started with Adeptly&nbsp;today</>,
	ctaText = "Start building",
	ctaHref = "https://my.adeptly.ai/",
	ctaSecondaryText = "Explore templates",
	ctaSecondaryHref = "/showcase/",
}) => {
	return (
		// <Appear
		// 	elementType="section"
		// 	aria-labelledby="callout"
		// 	className={styles.wrapper}
		// 	{...attrs}
		// >
		<Container>
			<div className={styles.body}>
				<div className={styles.headingWrapper}>
					<h2 id="callout" className={styles.heading}>
						{headingText}
					</h2>
				</div>
				<div id="cta" className={styles.cta}>
					<Button to={ctaHref} className={styles.button}>
						{ctaText}
					</Button>
					<Button
						variant="secondary"
						to={ctaSecondaryHref}
						className={styles.button}
					>
						{ctaSecondaryText}
					</Button>
				</div>
			</div>
		</Container>
		// </Appear>
	);
};
